import React from "react";
import { Link } from "react-router-dom";

class NotFound extends React.Component
{
    render()
    {
        return (
            <div className="text-center" id='error'>
                <h2>Oops! That page can't be found.</h2>
                <p>
                        It looks like nothing was found at this location.
                        Maybe try one of the links in the menu or press back to go to the previous page.
                </p>
            </div>
        );
    }
}

export default NotFound;